import { render } from "./ClientiInUscita.vue?vue&type=template&id=a6ec822a&scoped=true"
import script from "./ClientiInUscita.vue?vue&type=script&lang=js"
export * from "./ClientiInUscita.vue?vue&type=script&lang=js"

import "./ClientiInUscita.vue?vue&type=style&index=0&id=a6ec822a&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6ec822a"]])

export default __exports__